// BasiCard.tsx
import React from 'react';
import { Card, CardHeader, CardContent, Divider } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface BasicCardProps {
    title: string;
    subheader?: string;
    action?: React.ReactNode;
    children: React.ReactNode;
    headerSx?: SxProps<Theme>;
    contentSx?: SxProps<Theme>;
    cardSx?: SxProps<Theme>;
    withDivider?: boolean;
}

export const BasicCard = ({
    title,
    subheader,
    action,
    children,
    headerSx,
    contentSx,
    cardSx,
    withDivider,
}: BasicCardProps) => {
    return (
        <Card variant="outlined" sx={{ width: '100%', ...cardSx }}>
            <CardHeader
                title={title}
                subheader={subheader}
                action={action}
                sx={{ color: 'primary.main', ...headerSx }}
            />
            {withDivider && <Divider />}
            <CardContent sx={{ pt: 0, ...contentSx }}>{children}</CardContent>
        </Card>
    );
};
